import cn from '../../../utils/cn';
import Menu from '../../Menu';
import { Presets } from '../types';

const getPreset = (selectedPreset: Presets) => {
  const today = new Date();
  const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
  const last7Days = new Date(new Date().setDate(new Date().getDate() - 6));
  const last30Days = new Date(new Date().setDate(new Date().getDate() - 29));
  const thisMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1
  );
  const lastMonthStart = new Date(
    new Date().setMonth(new Date().getMonth() - 1, 1)
  );
  const lastMonthEnd = new Date(new Date().setMonth(new Date().getMonth(), 0));

  return {
    [Presets.TODAY]: [today, today],
    [Presets.YESTERDAY]: [yesterday, yesterday],
    [Presets.LAST_7_DAYS]: [last7Days, today],
    [Presets.LAST_30_DAYS]: [last30Days, today],
    [Presets.THIS_MONTH]: [thisMonth, today],
    [Presets.LAST_MONTH]: [lastMonthStart, lastMonthEnd],
  }[selectedPreset] as [Date, Date];
};

interface DatePickerPresetsProps {
  preset: Presets | null;
  presets?: Presets[];
  onChangePreset: (preset: Presets) => void;
  onChange: (dateRange: [Date | null, Date | null]) => void;
}

const DatePickerPresets = ({
  preset,
  presets,
  onChangePreset,
  onChange,
}: DatePickerPresetsProps) => {
  const presetsArray = presets || Object.values(Presets);

  const handlePreset = (selectedPreset: Presets) => {
    onChangePreset(selectedPreset);
    onChange(getPreset(selectedPreset));
  };

  return (
    <Menu className='-ml-2.5 flex h-full w-32 flex-col border-r border-gray-light p-0'>
      {presetsArray.map((presetItem) => (
        <Menu.Item
          key={presetItem}
          onClick={() => handlePreset(presetItem)}
          className={cn([
            'rounded-none border-primary px-2.5',
            preset === presetItem &&
              'border-r-2 border-primary bg-primary/10 font-bold text-primary hover:border-r-primary hover:bg-primary/10',
          ])}
        >
          {presetItem}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default DatePickerPresets;
